/* eslint-disable */
/* ***********************************************************
* A short word on how to use this automagically generated file.
* We're often asked in the ignite gitter channel how to connect
* to a to a third party api, so we thought we'd demonstrate - but
* you should know you can use sagas for other flow control too.
*
* Other points:
*  - You'll need to add this saga to sagas/index.js
*  - This template uses the api declared in sagas/index.js, so
*    you'll need to define a constant in that file.
*************************************************************/

import { call, put ,all,take } from 'redux-saga/effects'
import OrderActions from '../Redux/OrderRedux'

const responseToError = (response, title) => {
  console.tron.display({
    name: 'OrderSagas',
    preview: title,
    value: {
      response: response
    }
  })
  const apiResponse = typeof response.data != 'undefined' ? response.data : null
  const result = {
    error: {
      httpCode: response.status, // response.respInfo.status
      code:     typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['code'] : -1,
      title:    title,
      detail:   typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['detail'] : "Unknown",
    },
    logRef: typeof apiResponse.logRef != 'undefined' ? apiResponse.logRef : null
  }
  return result
} // responseToError

export const tagDetails = function* tagDetails(api, action) {
  try {
    console.tron.display({
      name: 'OrderSagas',
      preview: 'tagDetails details',
      value: {
        action: action
      }
    })
    const { postId } = action
    const response = yield call(api.tagDetails, postId)
    console.tron.display({
       name: 'api tagDetails response',
       preview: 'expand',
       value: {
         response: response
       }
    })

    if (response.ok) {
      const apiResponse = response.data
      yield put(OrderActions.orderComplete({tags: apiResponse.data, logRef: apiResponse.logRef}))
    } else {
      yield put(OrderActions.orderComplete(responseToError(response, "Tag Details Exception")))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'tagDetails',
      preview: "catch error",
      value: {
        message: e.message,
        e: e
      }
    })
  }
} // tagDetails

export const preflightOrder = function* preflightOrder(api, action) {
  try {
    console.tron.display({
      name: 'OrderSagas',
      preview: 'preflightOrder details',
      value: {
        action: action
      }
    })
    const { postId, itemId } = action
    const response = yield call(api.preflightOrder, postId, itemId)
    console.tron.display({
       name: 'api preflightOrder response',
       preview: 'expand',
       value: {
         response: response
       }
    })

    if (response.ok) {
      const apiResponse = response.data
      const item = apiResponse.data
      const meta = apiResponse.meta // might have failed, meta will say...
      yield put(OrderActions.orderComplete({item: item, meta: meta, logRef: apiResponse.logRef}))
    } else {
      yield put(OrderActions.orderComplete(responseToError(response, "Preflight Order Exception")))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'preflightOrder',
      preview: "catch error",
      value: {
        message: e.message,
        e: e
      }
    })
  }
} // preflightOrder

export const confirmOrder = function* confirmOrder(api, action) {
  try {
    console.tron.display({
      name: 'OrderSagas',
      preview: 'confirmOrder details',
      value: {
        action: action
      }
    })
    const { postId, itemId, params } = action
    const response = yield call(api.confirmOrder, postId, itemId, params)
    console.tron.display({
       name: 'api confirmOrder response',
       preview: 'expand',
       value: {
         response: response
       }
    })
    if (response.ok) {
      const apiResponse = response.data
      const lineItems = apiResponse.data
      const meta  = apiResponse.meta // might have failed, meta will say...
      yield put(OrderActions.orderComplete({lineItems: lineItems, meta: meta, logRef: apiResponse.logRef}))
    } else {
      yield put(OrderActions.orderComplete(responseToError(response, "Order Confirmation Exception")))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'confirmOrder',
      preview: "catch error",
      value: {
        message: e.message,
        e: e
      }
    })
  }
} // confirmOrder

export const purchaseOrder = function* purchaseOrder(api, action) {
  try {
    console.tron.display({
      name: 'OrderSagas',
      preview: 'purchaseOrder details',
      value: {
        action: action
      }
    })
    const { postId, params } = action
    const response = yield call(api.purchaseOrder, postId, params)
    console.tron.display({
       name: 'api purchaseOrder response',
       preview: 'expand',
       value: {
         response: response
       }
    })
    if (response.ok) {
      const apiResponse = response.data
      const order = apiResponse.order
      const meta  = {
        paypalKey: apiResponse.paypalKey,
        paypalUrl: apiResponse.paypalUrl
      }
      yield put(OrderActions.orderComplete({order: order, meta: meta, logRef: apiResponse.logRef}))
    } else {
      yield put(OrderActions.orderComplete(responseToError(response, "Purchase Exception")))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'purchaseOrder',
      preview: "catch error",
      value: {
        message: e.message,
        e: e
      }
    })
  }
} // purchaseOrder

export const purchaseSagaOrder = function* purchaseSagaOrder(api, action) {
  try {
    console.tron.display({
      name: 'purchaseSagaOrder ',
      preview: 'purchaseOrder details',
      value: {
        action: action
      }
    })
    const { data :{postId, params } } = action
    const response = yield call(api.purchaseOrder, postId, params)
    console.tron.display({
       name: 'api purchaseSagaOrder response',
       preview: 'expand',
       value: {
         response: response
       }
    })
    if (response.ok) {
      const apiResponse = response.data
      const order = apiResponse.order
      const meta  = {
        paypalKey: apiResponse.paypalKey,
        paypalUrl: apiResponse.paypalUrl
      }
     
      yield put(OrderActions.orderPurchaseSuccess(response))
    } else {
      console.tron.display({
        name: 'api purchaseSagaOrder response',
        preview: 'expand',
        value: {
          response: response
        }
     })
      yield put(OrderActions.orderPurchaseFailure(response))
    }
  }
  catch (e) {
    console.tron.display({
      name: 'purchaseOrder error',
      preview: "catch error",
      value: {
        message: e.message,
        e: e
      }
    })
  }
} // purchaseOrder

export function* getOrderEndorse(api, action) {
  try {
    const { data } = action
    console.tron.display({
    name: `getOrderEndorse saga`,
     preview :``,
    value: {
      action: action
    }
    })

    const response = yield call(api.getOrderEndorse, data)

    if (response.ok) {

      yield put(OrderActions.orderEndorseSuccess(response))
    } else {
      yield put(OrderActions.orderEndorseFailure(response))
    }
  } catch (e) {
    console.tron.display({
      name: 'getOrderEndorse error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }


}

export function* getOrderBought(api, action) {
  try {
    const { data } = action
    console.tron.display({
    name: `getOrderBought saga`,
     preview :``,
    value: {
      action: action
    }
    })

    const response = yield call(api.getOrderBought, data)

    if (response.ok) {

      yield put(OrderActions.orderBoughtSuccess(response))
    } else {
      yield put(OrderActions.orderBoughtFailure())
    }
  } catch (e) {
    console.tron.display({
      name: 'getOrderBought error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }


}
export function* getOrderSold(api, action) {
  try {
    const { data } = action

    const response = yield call(api.getOrderSold, data)

    if (response.ok) {

      yield put(OrderActions.orderSoldSuccess(response))
    } else {
      yield put(OrderActions.orderSoldFailure(response))
    }
  } catch (e) {
    console.tron.display({
      name: 'getOrderSold error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }


}
export function* shipOrder(api, action) {
  try {
    const { data } = action
     console.tron.display({
     name: `shipOrder`,
      preview :``,
     value: {
     state: action
     }
     })

    const response = yield call(api.shipProduct, data)

    if (response.ok) {

      yield put(OrderActions.orderShipSuccess(response))
    } else {
      console.tron.display({
        name: 'orderShipFailure error',
        preview: "expand",
        value: {
          message: response,

        }
      })
      yield put(OrderActions.orderShipFailure(response))
    }
  } catch (e) {
    console.tron.display({
      name: 'shipProduct error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }


}
export function* getOrderDetail(api, action) {
  try {
    const { data } = action
    console.tron.display({
    name: `getOrderDetail saga`,
     preview :``,
    value: {
      action: action
    }
    })

    const response = yield call(api.getOrderDetail, data)

    if (response.ok) {

      yield put(OrderActions.orderDetailSuccess(response))
    } else {
      yield put(OrderActions.orderDetailFailure(response))
    }
  } catch (e) {
    console.tron.display({
      name: 'getOrderDetail error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }


}
